export type GstSlab = 'IGST_0' | 'IGST_18' | 'CGST_SGST_9';

export const GST_SLAB_OPTIONS: { value: GstSlab; label: string; rate: number }[] = [
    { value: 'IGST_0', label: 'IGST 0%', rate: 0 },
    { value: 'IGST_18', label: 'IGST 18%', rate: 0.18 },
    { value: 'CGST_SGST_9', label: 'CGST 9% + SGST 9%', rate: 0.18 },
];

export type InvoiceType = 'INV' | 'CF';

export const INVOICE_TYPE_OPTIONS: { value: InvoiceType; label: string }[] = [
    { value: 'INV', label: 'INV — GST Bill' },
    { value: 'CF', label: 'CF — Cash Bill' },
];

export interface InvoiceService {
    accountId?: string | null;
    description: string;
    amount: number;
    ratePerUnitHour?: string;
    unitHour?: string;
    taxSlab: GstSlab | '';
    igstPercent?: number;
    cgstPercent?: number;
    sgstPercent?: number;
    igstAmount?: number;
    cgstAmount?: number;
    sgstAmount?: number;
    taxAmount?: number;
    totalAmount?: number;
}

export interface InvoicePartialPayment {
    _id?: string;
    id?: string;
    date: string;
    amount: number;
    accountId: string;
    accountName: string;
    remark?: string | null;
}

export interface Invoice {
    _id: string;
    id?: string;
    invoiceNumber: string;
    invoiceType?: InvoiceType;
    type?: InvoiceType;
    clientId: string | { _id: string; companyName?: string; ownerName?: string; displayName?: string };
    clientCompanyName?: string;
    services: InvoiceService[];
    gstSlab?: GstSlab | '';
    totalTax: number;
    totalDiscount: number;
    advancePaidAmount: number;
    partialPaidAmount?: number;
    totalAmount: number;
    totalPendingAmount?: number;
    partialPayments?: InvoicePartialPayment[];
    invoiceDate: string;
    yearForReminder: string[];
    optionForReminder: string[];
    additionalNote?: string;
    moveToSaleType?: 'loss' | 'tds' | null;
    moveToSaleAmount?: number;
    isDeleted?: boolean;
    createdAt?: string;
    updatedAt?: string;
}

export interface InvoiceFormData {
    invoiceNumber?: string;
    invoiceType: InvoiceType;
    clientId: string;
    services: InvoiceService[];
    totalTax: number;
    totalDiscount: number;
    advancePaidAmount: number;
    totalAmount: number;
    invoiceDate: string;
    yearForReminder: string[];
    optionForReminder: string[];
    additionalNote: string;
}

export interface InvoiceListResponse {
    success: boolean;
    message?: string;
    data?: {
        data?: Invoice[];
        items?: Invoice[];
        invoices?: Invoice[];
        pagination?: {
            total: number;
            page: number;
            limit: number;
            totalPages: number;
        };
        totalPendingAmount?: number;
        total?: number;
    };
}

export interface InvoiceDetailResponse {
    success: boolean;
    message?: string;
    data?: {
        invoice?: Invoice;
        result?: Invoice;
        [key: string]: any;
    };
}

export interface GstReportItem {
    _id?: string;
    invoiceNumber: string;
    invoiceDate: string;
    clientCompanyName?: string;
    clientOwnerName?: string;
    clientGst?: string;
    totalAmount: number;
    igstAmount: number;
    cgstAmount: number;
    sgstAmount: number;
}

export interface GstReportResponse {
    success: boolean;
    message?: string;
    data?: {
        data?: GstReportItem[];
        pagination?: {
            currentPage: number;
            totalPages: number;
            totalItems: number;
            itemsPerPage: number;
        };
        grandTotalAmount?: number;
        grandIgstAmount?: number;
        grandCgstAmount?: number;
        grandSgstAmount?: number;
    };
}
